import React from 'react';
import './App.css';
import {router} from "./Router/Router";
import {RouterProvider} from "react-router-dom";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "primereact/resources/primereact.css";
import "./styles/demo/Demos.scss"
import "./styles/layout/layout.scss";


function App() {
    return (
        <RouterProvider router={router}/>
    );
}

export default App;
